var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8006 13.7057L17.4783 19.8082C17.3464 19.9355 17.173 20 16.9996 20C16.8261 20 16.6527 19.9364 16.5208 19.8082L10.1985 13.7057C9.93384 13.4502 9.93384 13.0361 10.1985 12.7807C10.4631 12.5252 10.8922 12.5252 11.1568 12.7807L16.323 17.7673V3.65385C16.323 3.29292 16.6265 3 17.0004 3C17.3744 3 17.6778 3.29292 17.6778 3.65385V17.7673L22.8441 12.7807C23.1088 12.5252 23.5378 12.5252 23.8024 12.7807C24.067 13.0361 24.0653 13.4502 23.8006 13.7057Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8015 10.2184C13.6697 10.3457 13.4962 10.4101 13.3228 10.4101C13.1494 10.4101 12.9759 10.3465 12.8441 10.2184L7.67784 5.23168V19.3461C7.67784 19.7071 7.37436 20 7.00044 20C6.62652 20 6.32304 19.7071 6.32304 19.3461V5.23253L1.1568 10.2192C0.892162 10.4747 0.463113 10.4747 0.198477 10.2192C-0.066159 9.96379 -0.066159 9.54965 0.198477 9.29421L6.52084 3.19158C6.78547 2.93614 7.21452 2.93614 7.47916 3.19158L13.8015 9.29421C14.0662 9.54965 14.0662 9.96294 13.8015 10.2184Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.ad6782f9.svg";
export { ForwardRef as ReactComponent };